// eslint-disable-next-line no-unused-vars
import { getToken, setToken, removeToken,getExpiredAt, setExpiredAt, removeExpiredAt } from '@/utils/auth'
// import { resetRouter, addRoutes } from '@/router'
// 新特换接口
import { login,rlAdminUserInfo} from '@/api/system/index'


const state = {
  token: getToken(),
  expiredAt:getExpiredAt(),
  name: '',
  avatar: require('@/assets/images/avatar.png'),
  menus:[],
  permissions: [],
  cunChuTimeFalse:false,
  sleepReport:{},
  userInfoList:[]
}

const mutations = {
  setToken: (state, token) => {
    state.token = token
    setToken(token)
  },
  setUserExpiredAt: (state, expiredAt) => {
    state.expiredAt = expiredAt
    setExpiredAt(expiredAt)
  },
  setName: (state, name) => {
    state.name = name
  },
  setAvatar: (state, avatar) => {
    if (avatar) {
      state.avatar = process.env.VUE_APP_AVATAR_URL + avatar
    } else {
      state.avatar = require('@/assets/images/avatar.png')
    }
  },
  setMenus: (state, menus) => {
    state.menus = menus
  },
  setPermissions: (state, permissions) => {
    state.permissions = permissions
  },
  setCunChuTimeFalse:(state,cunChuTimeFalse)=>{
    state.cunChuTimeFalse = cunChuTimeFalse
  },
  setSleepReport:(state,sleepReport)=>{
    state.sleepReport = sleepReport
    localStorage.setItem('sleepReport',sleepReport)
  },
  setUserInfoList: (state, userInfoList) => {
    state.userInfoList = userInfoList
  },
}

const actions = {
  // login登录
  async login({ commit }, paras) {
    const res = await login(paras)
    if (res && res.success) {
      const token = res.data.accessToken
      commit('setToken', token)
      commit('setUserExpiredAt', res.data.expiredAt)
    }

    return res
  },

  async getLoginInfo({ commit }) {
    // 菜单信息
    const res = await rlAdminUserInfo()
    if (!res?.success) {
      return res
    }
    commit('setName', res.data.adminAccount)
    // commit('setAvatar', user.avatar)

    if (res.data.menuList && res.data.menuList.length > 0) {
      res.data.menuList.forEach(element => {
        if (element.list && element.list.length > 0) {
          element.list.forEach(subItem => {
            // 确保监测记录菜单默认显示
            if(subItem.menuPath === 'userBehavior/monitoringRecords'){
              subItem.hidden = false
            }else if(subItem.menuPath === 'userBehavior/medicalSleepReport' ||
              subItem.menuPath === 'organization/sleepReport' ||
              subItem.menuPath === 'userBehavior/sleepHandAccount' ||
              subItem.menuPath === 'userBehavior/reportLog' ||
              subItem.menuPath === 'userBehavior/meditationReport' ||
              subItem.menuPath === 'userBehavior/meditationReportLog' ||
              subItem.menuPath === 'userBehavior/sleepReport' ||
              subItem.menuPath === 'user/equipment') {
              subItem.hidden = true
            }else{
              subItem.hidden = false
            }
          });
        }
      });
    }
    commit('setMenus', res.data.menuList)
    commit('setUserInfoList',res.data)
    localStorage.setItem('loginInfo',JSON.stringify(res.data))
    // commit('setPermissions', res.data.permissions)
    // addRoutes(res.data.menuList)
    return res
  },

  setLocalLoginInfo({ commit, dispatch, state }) {
    let loginInfo = window.localStorage.getItem('loginInfo')
    if (loginInfo) {
      loginInfo = JSON.parse(loginInfo)
      commit('setName', loginInfo.adminAccount)
      commit('setAvatar', loginInfo.avatar)
      commit('setMenus', loginInfo.menuList)
      // addRoutes(loginInfo.menuList)
    } else {
      dispatch('logout')
    }
  },

  logout({ commit }) {
    commit('setToken', '')
    removeToken()
    commit('setUserExpiredAt', '')
    removeExpiredAt()
    // resetRouter()
    sessionStorage.removeItem('tabs')
    // localStorage.removeItem('loginInfo')

    commit('tabsView/delete_all_cached_views', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
